import React, { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "../assets/css/adminLayout.css";

const AdminLayout = () => {

  const navigate = useNavigate()

  useEffect(()=>{
    const token = localStorage.getItem('adminToken')
    if(!token){
      navigate('/')
    }
  },[navigate])

  function logoutUser() {
    if(window.confirm('Sure want to logout?')){
      localStorage.clear();
      window.location.reload()
    }
  }

  return (
    <div className="admin-layout">
      <aside className="sidebar">
        <h2>Admin</h2>
        <nav>
          <NavLink to="/admin/products/add">Add Product</NavLink>
          <NavLink to="/admin/products/edit">Edit Product</NavLink>
          <NavLink to="/admin/products/delete">Delete Product</NavLink>
          <NavLink to="/admin/quotes">Manage Quotes</NavLink>
          <NavLink to="/admin/requests">Product Requests</NavLink>
          <NavLink onClick={logoutUser}>Logout</NavLink>
        </nav>
      </aside>

      <main className="main-content">
        <header className="admin-header">
          <span>Admin Panel</span>
        </header>
        <div className="page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
